import React from 'react'
import CardContainer from './CustomBoxContainer'

export default function PlayBoardScreen() {
  return (
<>
    <CardContainer />
</>
  )
}
